import { render } from "./ChineseChess.vue?vue&type=template&id=687c510a"
import script from "./ChineseChess.vue?vue&type=script&lang=js"
export * from "./ChineseChess.vue?vue&type=script&lang=js"

import "./ChineseChess.vue?vue&type=style&index=0&id=687c510a&lang=css"

import exportComponent from "/builds/games/game.xiaofei.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__